module.exports = "<p>\n  alert works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/alert/alert.component.html
// module id = 421
// module chunks = 1